// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__9MLUH","blue":"Button_blue__PBfAP","blueCompact":"Button_blueCompact__l37IN","asLink":"Button_asLink__n1Qbm"};